module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.open),
      expression: "open"
    }],
    ref: "popup",
    staticClass: "dialog-wrapper",
    style: ({
      'z-index': _vm.zIndex
    }),
    on: {
      "click": _vm.handleWrapperClick
    }
  }, [_c('div', {
    staticClass: "dialog"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('v-button', {
    staticClass: "left",
    attrs: {
      "secondary": "",
      "text": _vm.cancelText
    },
    on: {
      "click": _vm.cancel
    }
  }), _vm._v(" "), _c('v-button', {
    staticClass: "right",
    attrs: {
      "primary": "",
      "text": _vm.okText
    },
    on: {
      "click": _vm.ok
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7738f486!./~/vue-loader/lib/selector.js?type=template&index=0!./src/comps/dialog-custom.vue
// module id = 872
// module chunks = 34